import { createAction, props } from '@ngrx/store';

import { CodedStatusMessage } from '@core/models/coded-status-message.model';
import { OptimizationResult } from '@core/models/optimization.model';
import { DeployStatusCode, PlanMetadataModel } from '@core/models/plan.model';

export const fetchPlans = createAction(
  '[Plan] Fetch plan Metadata',
  props<{
    id: string;
  }>()
);

export const setPlan = createAction(
  '[Plan] Set plan Metadata',
  props<{
    plan: PlanMetadataModel;
  }>()
);

export const optimizationUpdated = createAction(
  '[Plan] Optimization Updated',
  props<{ result: OptimizationResult }>()
);

export const optimizationDeleted = createAction(
  '[Plan] Optimization Deleted',
  props<{ jobId: string; planId: string }>()
);

export const deployStatusUpdated = createAction(
  '[Plan] Deploy Status Updated',
  props<{
    planId: string;
    configId: string;
    status: DeployStatusCode;
    updatedAt: number;
    name?: string;
    warnings?: CodedStatusMessage[];
    error?: CodedStatusMessage | null;
    /** Carried by the terminal event only, so the channel repaints with no follow-up read. */
    totalMessages?: number | null;
    sentCount?: number;
    failedCount?: number;
  }>()
);

export const clearPlan = createAction('[Plan] Clear Plan');

export const showGlobalDataOnly = createAction(
  '[Plan] set entity-auto-complete global data usage',
  props<{ entityAutoCompleteGlobalData: boolean }>()
);
